var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgMonitorTimeSeriesReportStandard = function SvgMonitorTimeSeriesReportStandard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 40 40",
    width: "1em",
    height: "1em",
    fill: "currentColor"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    fill: "#fabc3c",
    d: "M20 2a18 18 0 100 36 18 18 0 100-36z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 8h24v24H8z",
    fill: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 20.5a5 5 0 105 5 5.002 5.002 0 00-5-5zm1.65 7.35L23.5 25.7v-3.2h1v2.79l1.85 1.85zM25 11.5h-3.18a2.988 2.988 0 00-5.64 0H13a2.006 2.006 0 00-2 2v15a2.006 2.006 0 002 2h6.11a6.743 6.743 0 01-1.42-2H13v-15h2v3h8v-3h2v5.08a7.03 7.03 0 012 .6V13.5a2.006 2.006 0 00-2-2zm-6 2a1 1 0 111-1 1.003 1.003 0 01-1 1z",
    fill: "#fabc3c"
  })));
};
export default SvgMonitorTimeSeriesReportStandard;